module.exports = {"name":"mokit","version":"3.1.3"}


//////////////////
// WEBPACK FOOTER
// ./~/mokit/info.json
// module id = 2
// module chunks = 0